export default __webpack_public_path__ + "static/media/scdream7.fe362fa8.woff2";